<template>
	<el-dialog title="编辑" :visible.sync="isShow" width="40%" center :close-on-click-modal="false">
		<el-row>
			<el-form :model="infoForm" class="demo-form-inline" :rules="rules" ref="ruleForm" label-width="auto">
				<el-col :span="18">
					<el-form-item label="企业名称" prop="companyName">{{infoForm.companyName}}</el-form-item>
					<el-form-item label="项目名称" prop="projectName">{{infoForm.projectName}}</el-form-item>
					<el-form-item label="硬件名称" prop="moduleName">{{infoForm.moduleName}}</el-form-item>
					<el-form-item label="硬件编号" prop="equipmentNum">{{infoForm.equipmentNum}}</el-form-item>
					<el-form-item label="硬件厂家" prop="manufacturer">
						<el-input v-model="infoForm.manufacturer" placeholder="硬件厂家" size="small" clearable></el-input>
					</el-form-item>
					<el-form-item label="设备异常原因" prop="deviceAlarmType">
						<el-select v-model="infoForm.deviceAlarmType" style="width: 100%" placeholder="请选择" filterable clearable>
							<el-option
								v-for="item in deviceAbnormalDict"
								:key="item.value"
								:label="item.name"
								:value="item.value"
							>
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="设备状态" prop="recordType">
						<el-select v-model="infoForm.recordType" style="width: 100%" placeholder="请选择" filterable clearable>
							<el-option
								v-for="pro in workOrderStatusDict"
								:key="pro.value"
								:label="pro.name"
								:value="pro.value"
							>
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="维修人员" prop="repairUser">
						<el-input v-model="infoForm.repairUser" placeholder="维修人员" size="small" clearable></el-input>
					</el-form-item>
					<el-form-item label="维修日期" prop="repairTime">
						<el-date-picker
							class="picker"
							style="width: 100%;"
							v-model="infoForm.repairTime"
							type="date" 
							placeholder="选择日期"
							value-format="yyyy-MM-dd"
							clearable
						></el-date-picker>
					</el-form-item>
					<el-form-item label="备注" prop="remarks">
						<el-input v-model="infoForm.remarks" placeholder="备注" size="small" clearable></el-input>
					</el-form-item>
				</el-col>
			</el-form>
		</el-row>
		<div class="btn-container">
			<el-button @click="isShow = false" size="small"> 取 消 </el-button>
			<el-button type="primary" @click="confirmHandler" size="small" :loading="confirmLoading"> 确 定 </el-button>
		</div>
	</el-dialog>
</template>

<script>
import { editHardwareAlarmStatisticsDaily, getHardwareReportDetail } from '@/api/hardwarestatistic';
export default {
	props: {
		deviceAbnormalDict: {
			type: Array,
			default: () => []
		},
		workOrderStatusDict: {
			type: Array,
			default: () => []
		}
	},
	data() {
		return {
			isShow: false,
			infoForm: {
				companyName: '',
				projectName: '',
				moduleName: '',
				equipmentNum: '',
				manufacturer: '',
				deviceAlarmType: '',
				recordType: '',
				repairUser: '',
				repairTime: '',
				remarks: '',
				id: ''
			},
			rules: { 
				manufacturer: [{ required: true, message: '请输入硬件厂商', trigger: 'blur' }], // 添加硬件厂商验证
				deviceAlarmType: [{ required: true, message: '请选择设备异常原因', trigger: 'blur' }], // 添加设备异常原因验证
				recordType: [{ required: true, message: '请选择设备状态', trigger: 'blur' }] // 添加设备状态验证
			},
			confirmLoading: false
		}
	},
	methods: {
		fillParamsFromInfoForm() {
			let params = {
				id: this.infoForm.id,
				manufacturer: this.infoForm.manufacturer,
				deviceAlarmType: parseInt(this.infoForm.deviceAlarmType, 10), // 转换为整数
				recordType: parseInt(this.infoForm.recordType, 10), // 转换为整数
				repairUser: this.infoForm.repairUser,
				repairTime: this.infoForm.repairTime,
				remarks: this.infoForm.remarks
			};

			return params;
		},
		confirmHandler() {
			this.$refs.ruleForm.validate((valid) => {
				if (valid) {
					this.confirmLoading = true;
					let params = this.fillParamsFromInfoForm();
					editHardwareAlarmStatisticsDaily(params).then((res) => {
						this.confirmLoading = false;
						if (res.data.statusCode === 200) {
							this.closeDialog();
							this.$emit('refreshTable');
							this.$message({
								type: 'success',
								message: '编辑成功'
							});
						}
					}).catch(() => {})
				} else {
					console.log('error submit!!');
					return false;
				}
			})
		},
		openDialog(row) {
			// 确保 row 包含所有必要的字段
			const validRow = {
				companyName: row.companyName || '',
				projectName: row.projectName || '',
				moduleName: row.moduleName || '',
				equipmentNum: row.equipmentNum || '',
				manufacturer: row.manufacturer || '',
				deviceAlarmType: row.deviceAlarmType || '',
				recordType: row.recordType || '',
				repairUser: row.repairUser || '',
				repairTime: row.repairTime || '',
				remarks: row.remarks || '',
				id: row.id || ''
			};
			
			this.infoForm = validRow;

			getHardwareReportDetail({ id: row.id }).then(res => {
				if(res.data.statusCode === 200) {
					this.infoForm = Object.assign({}, this.infoForm, { repairUser: res.data.data.repairUser, repairTime: res.data.data.repairTime});
					console.log(this.infoForm);
					this.isShow = true;
				}
			}).catch(() => {})
			
		},
		closeDialog() {
			this.isShow = false;
		}
	}
}
</script>

<style lang="scss" scoped>
.btn-container {
	width: 100%;
	text-align: center;
}
</style>